<template>
  <div>
    <div class="container-fluid relative">
      <section class="mw7 relative z-1 center pt4 pt5-ns">
          <div class="tc">
            <h1 class="page-title pt4 is-gravitas-important ttu">{{ post.title }}</h1>
          </div>
      </section>
      <div class="absolute z-0 mw4 mw5-ns topography topography-top-left-wrap">
          <simple-svg
              :filepath="'/assets/images/svg/gdz18-topography.svg'"
              :id="'topography-top-left'"
          ></simple-svg>
      </div>
    </div>
    <div class="container-fluid relative">
      <section class="mw7 relative z-1 center pv3 pv4-ns is-navy">
        <div class="row middle-sm">
          <div v-if="post['Featured Image']" class="col-xs-12 col-sm-4">
            <img class="db center content-image" :src="post['Featured Image']">
          </div>
          <div class="col-xs-12 col-sm-8 center" v-html="post.content">
            <!-- content -->
          </div>
        </div>
        <div class="dn db-ns bg plus-signs z-0"></div>
      </section>
    </div>
  </div>
</template>

<script>
import Marked from 'marked';
export default {
  //template: '#generic-page',
  props: ['id','pageName'],
  metaInfo () {
    return {
      title: this.post.seo_title,
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the hyphen
        return titleChunk ? `${titleChunk} | ` + this.$site_name : this.$site_name;
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.post.seo_description }
      ]
    }
  },
  data () {
    return {
      isLoading: false,
    }
  },
  computed: {
    post: function () {
      var postData = this.$store.getters.filterPostsByUrl(this.$route.path);
      return postData[0];
    }
  },
  methods : {
    //
  }
}
</script>
